import { Component, OnInit, Input} from '@angular/core';
import { InterviewItem } from '../interview';
import { Entrevista } from '../entrevista';


@Component({
  selector: 'app-interview-grid',
  templateUrl: './interview-grid.component.html',
  styleUrls: ['./interview-grid.component.css']
})
export class InterviewGridComponent implements OnInit {

  @Input() entrevistas : Entrevista[]
  @Input() single: boolean

  _MEDIAURL = 'https://www.industriapaisaia.eus';
  //_MEDIAURL = 'https://dedalo.anorgatarrak.eus';

  constructor() {}

  ngOnInit() {}

}
